const PaymentPanelEnum = {
    CONTACT: 'addresses',
    DISCOUNT: 'discount',
    VAT_TAX: 'vatTax',
    PAYMENT: 'payment',
};

export default PaymentPanelEnum;
